import dayjs from 'dayjs';
import { DateFormat } from '../../constants/data';

export const GetDisabledDates = (ranges) => {
  const disabledDates = [];

  if (ranges.length) {
    ranges.forEach(({ sowingDate, harvestDate }) => {
      let current = dayjs(sowingDate);
      const end = dayjs(harvestDate);

      while (current.isBefore(end) || current.isSame(end)) {
        disabledDates.push(current.format(DateFormat));
        current = current.add(1, 'day');
      }
    });
  }

  return disabledDates;
};